<template>
    <div class="workordrAssign">
        <div class="workordr_tip">
            <i class="icon-icon_tip"></i> 中心确认是否归档
        </div>
        <div class="workordr_content">
            <div class="workordr_content_title">
                <div class="workordr_content_title_left">
                    <span></span>
                    <p>承办单位处理结果</p>
                </div>
            </div>
            <div class="workordr_result">
                <div class="workordr_result_title">
                    <span class="icon-build"></span>
                    <span>
                       {{queryWordorderMessageData.czCzdwmc}}
                    </span>
                    <span><el-icon><clock/></el-icon></span>
                    <span>
                       {{queryWordorderMessageData.updateTime}}
                    </span>
                </div>
                <div class="workordr_result_main">
                    {{queryWordorderMessageData.czCzjgwb}}
                </div>
            </div>
        </div>
        <!--<TimeLine_file></TimeLine_file>-->
    </div>
    <div class="workordrAssign">
        <div class="workordr_content">
            <div class="workordr_content_title">
                <div class="workordr_content_title_left">
                    <span></span>
                    <p>工单归档</p>
                    <!--<el-radio-group v-model="ruleForm.czCzjgzt" >-->
                        <!--<el-radio-button label="1">归档</el-radio-button>-->
                        <!--<el-radio-button label="0">重新发起</el-radio-button>-->
                    <!--</el-radio-group>-->
                </div>
            </div>
            <el-form label-width="90px"
                     :model="ruleForm"
                     :rules="rules"
                     label-position="left"
                     ref="ruleFormRef">
                <div class="workordr_main">
                    <el-form-item label="处理结果" prop="czCzjgwb">
                        <el-input v-model="ruleForm.czCzjgwb" maxlength="2000" show-word-limit type="textarea"/>
                    </el-form-item>
                    <!--<el-form-item label="发起原因" v-if="ruleForm.czCzjgzt=='0'" prop="czCzjgwb">-->
                        <!--<el-input v-model="ruleForm.czCzjgwb" maxlength="2000" show-word-limit type="textarea"/>-->
                    <!--</el-form-item>-->
                    <!--<Workorder_file @deleteFile="deleteFile" @fileListToParent="fileListToParent"></Workorder_file>-->
                </div>
                <el-form-item class="workordrAssign_btn">
                    <div class="workordrAssign_btn_cancle" @click="cancleClick">
                        取消
                    </div>
                    <div class="workordrAssign_btn_sure" @click="submitForm(ruleFormRef)">
                        确认
                    </div>
                    <!--<el-popconfirm title="确认提交区中心吗？">-->
                    <!--<template #reference>-->
                    <!--<div class="workordrAssign_btn_sure">-->
                    <!--确认-->
                    <!--</div>-->
                    <!--</template>-->
                    <!--</el-popconfirm>-->
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {reactive, computed, ref, getCurrentInstance, onMounted,watch} from 'vue'
    import {useStore} from 'vuex';
    import {ElMessageBox,ElLoading} from 'element-plus'
    import TimeLine_file from "../timeLine/TimeLine_file.vue"
    export default {
        name: "WorkProgress_gd.vue",
        props: ["gdId","workProgressComponentChildData"],
        components: {
            TimeLine_file
        },
        setup(props, context) {
            const store = useStore();
            const {proxy} = getCurrentInstance();
            const ruleFormRef = ref()
            const ruleForm = reactive({
                "czCzlx": 'GDGD',
                "gdId": props.gdId,
                czCzjgwb:props.workProgressComponentChildData.czCzjgwb,
                czCzjgwb:"",
            });

            let queryWordorderMessageData = ref([])
            const rules = reactive({
                czCzjgwb: [
                    {required: true, message: "请输入处理结果", trigger: 'blur'},
                ]
            });
            // watch(()=>ruleForm.czCzjgzt,(newVal)=>{
            //     if(newVal =="1"){
            //         rules.czCzjgwb[0].message="请输入处理结果"
            //     }else{
            //         rules.czCzjgwb[0].message="请输入驳回原因"
            //     }
            // })
            // const radioGroupChange = (param) => {
            //     if (param == 1) {
            //         ruleForm.czCzjgwb = "";
            //     }
            // }
            const submitForm = (param) => {
                if (!param) return
                let loading;
                param.validate((valid, fields) => {
                    if (valid) {
                        ElMessageBox.confirm('请确认是否继续', '提示', {
                            confirmButtonText: '确认',
                            cancelButtonText: '取消',
                            callback: (action) => {
                                if(action=="confirm"){
                                    loading = ElLoading.service({
                                        lock: true,
                                        text: 'Loading',
                                        background: 'rgba(0, 0, 0, 0.7)',
                                    })
                                    proxy.$axios.post("/jgfast/wgsj/gdcz", ruleForm).then((res) => {
                                        context.emit("workProgressSure");
                                        loading.close()
                                    }).catch(e=>{
                                        loading.close();
                                    });
                                }
                            },
                        })
                    } else {
                        console.log('error submit!', fields)
                    }
                })
            };
            onMounted(() => {
                queryWordorderMessage();
            })
            const queryWordorderMessage = () => {
                proxy.$axios.post("/jgfast/wgsj/selCbdwcljg", {
                    "gdId": props.gdId,
                    "czFpdxid":props.workProgressComponentChildData.czFpdxid,
                    "czFpdxjs":props.workProgressComponentChildData.czFpdxjs
                }).then((res) => {
                    queryWordorderMessageData.value = res.data;
                });
            }
            //取消事件
            const cancleClick = () => {
                context.emit("workProgressCancle");
            }
            const fileListToParent=(param)=>{
                if(param){
                    ruleForm.fileIds.push(param.id);
                }
            }
            const deleteFile=(param)=>{
                ruleForm.fileIds.splice(param, 1)
            }
            return {
                ruleForm,
                rules,
                ruleFormRef,
                submitForm,
                queryWordorderMessageData,
                cancleClick,
                fileListToParent,
                deleteFile
            }
        }
    }
</script>

<style scoped>

</style>

